import { Landmark } from "lucide-react";
import { corporateEventConfig } from "~/lib/corporate-events";
import { formatDate } from "~/lib/format";
import type { CorporateEventsResponse } from "~/types/corporate";
import { CardFooterLink, OverviewCard } from "./card";

/** Firemní události — teaser of the newest corporate events extracted from Sbírka listin. */
export function EventsTeaserCard({ events }: { events: CorporateEventsResponse | null }) {
	if (!events || events.events.length === 0) return null;

	return (
		<OverviewCard icon={Landmark} title="Firemní události" hue="violet">
			<ul className="flex flex-col gap-2.5">
				{events.events.slice(0, 3).map((event) => {
					const config = corporateEventConfig(event.eventType);
					return (
						<li key={event.id} className="flex items-baseline gap-3 text-sm">
							<span className="shrink-0 font-mono text-xs text-muted-foreground tabular-nums w-20">
								{formatDate(event.eventDate)}
							</span>
							<span className="min-w-0">
								<span className="font-medium">{config.label}</span>
								{event.title && event.title !== config.label && (
									<span className="text-muted-foreground"> — {event.title}</span>
								)}
							</span>
						</li>
					);
				})}
			</ul>
			<CardFooterLink to="historie">Všechny události</CardFooterLink>
		</OverviewCard>
	);
}
